// Type Imports
import { IInteractionRpc } from "@pulse-ui/codegen/generated_ts/managed_algo";

// Component Imports
import VerticalTabs from "../VerticalTabs/VerticalTabs";

// MUI Imports
import { Dialog, DialogContent, DialogTitle, IconButton, DialogTitleProps as MuiDialogTitleProps } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";


const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps extends Omit<MuiDialogTitleProps, 'onClose'> {
  onClose?: () => void;
}

function CustomDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: '#fff',
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const InteractionsModal = ({
  open,
  interaction,
  selectedBotData,
  connectionId,
  initialRpcName,
  selectedRowStatus,
  handleClose,
  onRpcSuccess,
}: {
  open: boolean;
  interaction: Record<string, IInteractionRpc> | null;
  selectedBotData: any;
  connectionId: string | null;
  initialRpcName?: string | null;
  selectedRowStatus?: string | null;
  handleClose: () => void;
  onRpcSuccess?: () => void;
}) => {
  const theme = useTheme();
  return (
    <div>
      <CustomDialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            boxShadow: "0px 0px 10px #777",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}
        fullScreen
      >
        <CustomDialogTitle
          sx={{ backgroundColor: theme.palette.bg["800"], color: theme.palette.bg[50] }}
          onClose={handleClose}
        >
          Interactions
        </CustomDialogTitle>

        <DialogContent dividers sx={{ backgroundColor: theme.palette.bg["50"], height: '100%' }}>
          {interaction && (
            <VerticalTabs
              interaction={interaction}
              selectedBotData={selectedBotData}
              connectionId={connectionId}
              initialRpcName={initialRpcName}
              selectedRowStatus={selectedRowStatus}
              onRpcSuccess={onRpcSuccess}
            />
          )}
        </DialogContent>
      </CustomDialog>
    </div>
  );
};
export default InteractionsModal;
